import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listRoles:[],
  listRolesActivas:[]
};

export const mutations = {
  GET_ROLES({ context }, roles) {
    let roles_array = [];
    Object.entries(roles).forEach(([key, val]) => roles_array.push(val));
    return (state.listRoles = roles_array);
  }
};

export const actions = {
  GET_ROLES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_ROLES", response.data.data.roles);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_ROLES({ commit }, role) {
    return new Promise((resolve, reject) => {
      console.log(role);
      commit("SET_LOADING", true);
      ApiService.post(role)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_ROLE({ commit }, dataRole) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataRole)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_ROLE({ commit }, role_id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(role_id)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {
  listRoles: state => state.listRoles,
  listRolesActivas:(state, getters )=>{
    return getters.listRoles.filter(rol => rol.deleted_at == null)
  },
};
